class StickyHeader {
    constructor($, _) {
        window.addEventListener('scroll', () => {
            this.updateUI()
        })
    }

    updateUI() {
        if (window.scrollY > 80) {
            document.body.classList.add('compact-header')
        } else {
            document.body.classList.remove('compact-header')
        }
    }
}

(function () {
    new StickyHeader()
})()